import Agent from './agent/Agentv2';
import ContentConfig from '../config/ContentConfig';
import LocalState from '../state/LocalState';
import Node from './agent/Node';
import SDKConfig from '../common/SDKConfig';
import logger from '../log';
import { Item } from './agent/interfaces';
import { SourceType } from '../common/constants';
import { Detection } from '../common/Detector/detectForSource';
import { ReporterSections } from '../common/Reporter/constants';
import { dispatchUpdateReportEvent } from '../events/dispatch';

const log = logger.getLogger(__filename);
const config = ContentConfig.getInstance();

const DEFAULT_VERSION = '2.0';

export function updateReporterWebrtcSection(node: Node, version: string): void {
  const { nodeId, agentId } = node;
  const v = version || DEFAULT_VERSION;
  dispatchUpdateReportEvent({
    value: { webrtc: { v, nodeId, agentId } },
    section: ReporterSections.ECDN11
  });
}

function swapPreidForGitSha(version: string, gitsha: string): string {
  return version.replace(/-\w+\.\d{1,2}/, `.${gitsha}`);
}

const CDN_HOST_DEFAULT = 'https://cdn.kollective.app';
const CDN_PROD_PATH = '/kernel/';
const CDN_PRE_PATH = '/kernel-pre/';

function getHostPath(isPre: boolean) {
  const root_path = isPre ? CDN_PRE_PATH : CDN_PROD_PATH;
  const origin = new URL(config.sdkUrl || CDN_HOST_DEFAULT).origin;
  return new URL(root_path, origin);
}

function getUrl(ext: string, version: string, gitCommit: string): string {
  const isPre = version.includes('-next');
  const base = getHostPath(isPre);
  const fileName = `wasmkernel-${
    isPre ? swapPreidForGitSha(version, gitCommit) : version
  }.${ext}`;
  return base + fileName;
}

function getKernelConfig(sdkConfig: SDKConfig): string {
  const { version, gitCommit } = sdkConfig;
  return getUrl('wasm', version as string, gitCommit as string);
}

export default function getAgent(
  options: {
    content: { tenantId: string; id: string; token: string; items: Item[] };
    state: LocalState;
    detection: Detection;
    fallbackToCDN: (err: Error) => void;
    sourceType: SourceType;
  },
  sdkConfig: SDKConfig
): Agent {
  const { fallbackToCDN, content, detection, sourceType } = options;
  log.debug({ options, sdkConfig });

  if (!config.peering.wasmUrl) {
    config.peering.wasmUrl = getKernelConfig(sdkConfig);
  }
  return new Agent(options.state, content, detection.playType, sourceType, {
    onpeerconfigured: ({ node }: { node: Node }) => {
      updateReporterWebrtcSection(node, '2.0');
    },
    oninitialized: () => {
      // Intentionally left empty
    },
    onshutdown: (err: Error) => fallbackToCDN(err)
  });
}
